// extracted by mini-css-extract-plugin
module.exports = {"container":"MyAppSettings_container__2vTBj","modal":"MyAppSettings_modal__Spq0I","content":"MyAppSettings_content__3Rb3A"};